import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowsClockwise as RefreshCw, X } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

// One calm, app-wide line when Google access has genuinely lapsed, so nobody
// finds out from an email first. Transient Google trouble never triggers it.
export const SheetReconnectBanner = () => {
  const { pathname } = useLocation();
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!pathname.startsWith("/app")) { setStatus(null); return; }
    let live = true;
    (async () => {
      try {
        const res = await fetch(`${API}/api/caddy/sheet-status`, { credentials: "include" });
        if (!res.ok) return;
        const body = await res.json();
        if (live) setStatus(body);
      } catch { /* offline, say nothing */ }
    })();
    return () => { live = false; };
  }, [pathname]);

  if (hidden || !status?.needs_reconnect) return null;

  const ret = encodeURIComponent(window.location.pathname + window.location.search);
  return (
    <div
      className="w-full px-4 py-2.5"
      style={{ background: "var(--pr-tint-gold)", borderBottom: "1px solid var(--pr-line)" }}
      data-testid="sheet-reconnect-banner"
    >
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <p className="text-xs sm:text-[13px] leading-snug flex-1" style={{ color: "var(--pr-ink)" }}>
          <b>Your Google Sheet has stopped syncing.</b> Your wins are still safe here, reconnect once
          and the sheet catches up.
        </p>
        {status.reconnect_path && (
          <a
            href={`${API}${status.reconnect_path}&ret=${ret}`}
            className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-bold flex-shrink-0 pr-btn-primary"
            data-testid="sheet-reconnect-banner-cta"
          >
            <RefreshCw className="w-3 h-3" /> Reconnect Google
          </a>
        )}
        <button
          onClick={() => setHidden(true)}
          className="p-1 flex-shrink-0"
          aria-label="Hide for now"
          data-testid="sheet-reconnect-banner-dismiss"
        >
          <X className="w-4 h-4" style={{ color: "var(--pr-muted)" }} />
        </button>
      </div>
    </div>
  );
};

export default SheetReconnectBanner;
